import Flux from 'lib/flux';
import MessageService from 'services/message';
import MessageConstants from 'constants/message';

const MessageActionCreator = Flux.createActionCreator({
  sendMessage(params, onSuccessCallback) {
    this.dispatchAction(MessageConstants.SEND_MESSAGE);
    MessageService.sendMessage(params).then(
      (resp) => {
        this.dispatchAction(MessageConstants.SEND_MESSAGE_COMPLETED);
        onSuccessCallback(resp);
      },
      (_resp) => {
        const payload = { errors: { base: 'Something went wrong.' } };
        this.dispatchAction(MessageConstants.SEND_MESSAGE_FAILED, payload);
      }
    );
  },
});

export default MessageActionCreator;
